var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"percent-w100",attrs:{"placeholder":"请选择","value-key":"url"},on:{"change":_vm.changeFunc},model:{value:(_vm.activePage),callback:function ($$v) {_vm.activePage=$$v},expression:"activePage"}},_vm._l((_vm.pages),function(item){return _c('el-option',{key:item.url,attrs:{"value-key":item.name,"label":item.name,"value":item}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ffebf1a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setlink/part/Pages.vue
// module id = null
// module chunks = 